import React, { useEffect, useRef, useState } from "react";
import { string } from "prop-types";

import { TOPICS_FILTER } from "./handler";

import "./tag-filter.m.css";

const TagFilter = ({ slug, lang, pageType }) => {
  if (lang !== "bn") {
    return null;
  }

  const filterType = TOPICS_FILTER.find((item) => item.slug === slug);

  if (pageType === "tag-page" && !filterType) {
    return null;
  }

  if (pageType === "section-page" && slug !== "/samagrabangladesh") {
    return null;
  }

  const [tag1, setTag1] = useState("নির্বাচন করুন বিভাগ");
  const [tag2, setTag2] = useState("নির্বাচন করুন জেলা");
  const [tag3, setTag3] = useState("নির্বাচন করুন উপজেলা");

  const [showTag1Dropdown, setTag1Dropdown] = useState(false);
  const [showTag2Dropdown, setTag2Dropdown] = useState(false);
  const [showTag3Dropdown, setTag3Dropdown] = useState(false);

  const [tag2Items, setTag2Items] = useState(null);
  const [tag3Items, setTag3Items] = useState(null);

  const [selectedTagSlug, setSelectedTagSlug] = useState(null);

  const tag1Items = TOPICS_FILTER.filter((item) => item["parent-external-id"] === null);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          showTag1Dropdown && setTag1Dropdown(false);
          showTag2Dropdown && setTag2Dropdown(false);
          showTag3Dropdown && setTag3Dropdown(false);
        }
      }
      document.addEventListener("click", handleClickOutside);
      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }, [ref, showTag1Dropdown, showTag2Dropdown, showTag3Dropdown]);
  }

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  const showDropdownHandler = (type) => {
    if (type === "tag1") {
      setTag1Dropdown(!showTag1Dropdown);
      setTag2Dropdown(false);
      setTag3Dropdown(false);
    } else if (type === "tag2") {
      setTag1Dropdown(false);
      setTag2Dropdown(!showTag2Dropdown);
      setTag3Dropdown(false);
    } else if (type === "tag3") {
      setTag1Dropdown(false);
      setTag2Dropdown(false);
      setTag3Dropdown(!showTag3Dropdown);
    } else {
      setTag1Dropdown(false);
      setTag2Dropdown(false);
      setTag3Dropdown(false);
    }
  };

  const tag1ItemsHandler = (tag) => {
    setSelectedTagSlug(tag.slug);
    setTag1(tag.name);
    setTag2("নির্বাচন করুন জেলা");
    setTag3("নির্বাচন করুন উপজেলা");
    setTag1Dropdown(false);
    const tag2Items = TOPICS_FILTER.filter((item) => item["parent-external-id"] === tag["external-id"]);
    setTag2Items(tag2Items);
  };

  const tag2ItemsHandler = (tag) => {
    setSelectedTagSlug(tag.slug);
    setTag2(tag.name);
    setTag3("নির্বাচন করুন উপজেলা");
    setTag2Dropdown(false);
    const tag3Items = TOPICS_FILTER.filter((item) => item["parent-external-id"] === tag["external-id"]);
    setTag3Items(tag3Items);
  };

  const tag3ItemsHandler = (tag) => {
    setSelectedTagSlug(tag.slug);
    setTag3(tag.name);
  };

  const navigate = () => {
    if (selectedTagSlug) {
      window.location.href = `/topic/${selectedTagSlug}`;
    }
  };

  const customStyle = {
    color: "#333333",
  };

  const getFilter = ({ title, showDropdown, customStyle, dropdownHandler, tag, tagItems, tagItemsHandler }) => {
    return (
      <div styleName="filter" data-test-id="tag-filter">
        <div styleName="title">{title}</div>
        <div
          styleName={`tag-filter-wrapper ${showDropdown ? "open-dropdown" : ""}`}
          style={customStyle}
          onClick={dropdownHandler}
          ref={wrapperRef}
        >
          {tag}
        </div>
        {showDropdown && (
          <ul styleName="dropdown-wrapper" data-test-id="tag-filter-dropdown">
            {tagItems && tagItems.length > 0 ? (
              tagItems.map((item) => (
                <li styleName="dropdown-item" onClick={() => tagItemsHandler(item)} key={item["external-id"]}>
                  {item.name}
                </li>
              ))
            ) : (
              <li styleName="dropdown-item">no items</li>
            )}
          </ul>
        )}
      </div>
    );
  };

  return (
    <div styleName="wrapper">
      {getFilter({
        title: "বিভাগ",
        showDropdown: showTag1Dropdown,
        customStyle: tag1 === "নির্বাচন করুন বিভাগ" ? {} : customStyle,
        dropdownHandler: () => showDropdownHandler("tag1"),
        tag: tag1,
        tagItems: tag1Items,
        tagItemsHandler: tag1ItemsHandler,
      })}
      {getFilter({
        title: "জেলা",
        showDropdown: showTag2Dropdown,
        customStyle: tag2 === "নির্বাচন করুন জেলা" ? {} : customStyle,
        dropdownHandler: () => showDropdownHandler("tag2"),
        tag: tag2,
        tagItems: tag2Items,
        tagItemsHandler: tag2ItemsHandler,
      })}
      {getFilter({
        title: "উপজেলা",
        showDropdown: showTag3Dropdown,
        customStyle: tag3 === "নির্বাচন করুন উপজেলা" ? {} : customStyle,
        dropdownHandler: () => showDropdownHandler("tag3"),
        tag: tag3,
        tagItems: tag3Items,
        tagItemsHandler: tag3ItemsHandler,
      })}
      <button styleName="filter-button" data-test-id="filter-button" onClick={navigate}>
        Filter Search
      </button>
    </div>
  );
};

TagFilter.propTypes = {
  slug: string,
  lang: string,
  pageType: string,
};

export default TagFilter;
